import React from 'react';
import BusinessNotificationItem from './BusinessNotificationItem.jsx';
import style from './style.scss';

class BusinessNotification extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {

    }
  }

  render() {
    return (
      <section className="business-notif">
        <h2 className='business-notif-title'>{this.props.title}</h2>
        <div className='wrap-business-notif-item'>
          <BusinessNotificationItem/>
          <BusinessNotificationItem/>
          <BusinessNotificationItem/>
        </div>
        {
          this.props.hideViewAll ? null : (
            <p className='business-notif-view-all'> <a href='' className='view-all-link'>Xem tất cả</a></p>
          )
        }
      </section>
    );
  }
}

export default BusinessNotification;


// WEBPACK FOOTER //
// ./components/users/sub-view/the-news/notification/BusinessNotification.jsx